import { isNil } from 'lodash'
import { ReactElement } from 'react'
import { IconBaseProps } from 'react-icons'
import { FiBarChart2, FiCode, FiFile, FiSettings } from 'react-icons/fi'
import { IoRocketOutline } from 'react-icons/io5'
import { RxDashboard, RxHome, RxInput, RxLightningBolt, RxTable } from 'react-icons/rx'
import { SiStorybook } from 'react-icons/si'
import { TbColumns } from 'react-icons/tb'
import { BreadcrumbObjectType } from '~/common/generated/apollo-operations'
import { cn } from '../../@/lib/utils'
import { PivotTableIcon } from '../pivot-table/icons/PivotTableIcon'

interface WorkspaceIconProps extends IconBaseProps {
  workspaceType?: BreadcrumbObjectType
  icon?: ReactElement
}
/**
 * Render icon for workspace in breadcrumbs
 */
export function WorkspaceIcon({ icon, workspaceType, ...rest }: WorkspaceIconProps) {
  if (icon) {
    return icon
  } else if (!isNil(workspaceType)) {
    switch (workspaceType) {
      case BreadcrumbObjectType.ORGANIZATION:
        return <RxHome {...rest} />
      case BreadcrumbObjectType.PROJECT:
        return <RxDashboard {...rest} />
      case BreadcrumbObjectType.TABLE:
        return <RxTable {...rest} />
      case BreadcrumbObjectType.TABLE_ROW:
        return <TbColumns {...rest} className={cn('scale-110', rest.className)} />
      case BreadcrumbObjectType.DOCUMENT:
        return <FiFile {...rest} />
      case BreadcrumbObjectType.FORM:
      case BreadcrumbObjectType.FORM_V2:
        return <RxInput {...rest} />
      case BreadcrumbObjectType.WORKFLOW:
      case BreadcrumbObjectType.WORKFLOW_V2:
      case BreadcrumbObjectType.WORKFLOW_V2_TRIGGER:
        return <RxLightningBolt {...rest} />
      case BreadcrumbObjectType.USER:
        return <FiSettings {...rest} />
      case BreadcrumbObjectType.ACTION:
        return <IoRocketOutline {...rest} />
      case BreadcrumbObjectType.ACTION_STEP:
        return <SiStorybook {...rest} />
      case BreadcrumbObjectType.CHART:
        return <FiBarChart2 {...rest} />
      case BreadcrumbObjectType.EMBED:
        return <FiCode {...rest} />
      case BreadcrumbObjectType.WORKSPACE:
        return <RxDashboard {...rest} />
      case BreadcrumbObjectType.PIVOT_TABLE:
        return <PivotTableIcon className={cn('scale-110', rest.className)} size={rest.size} />
      case BreadcrumbObjectType.TABLE_COLUMN:
      case BreadcrumbObjectType.TABLE_CELL:
      case BreadcrumbObjectType.FORM_PAGE:
      case BreadcrumbObjectType.FORM_CATEGORY:
      case BreadcrumbObjectType.FORM_FIELD:
      case BreadcrumbObjectType.FORM_V2_INPUT:
        return null
    }
  } else {
    return null
  }
}
